import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './signup_card.scss';
import './signup_form.scss';
import { configAxios } from '../../axiosUtils';
import { Crash } from '../../components/crash/Crash';
import { SignUpProvider } from './SignUpContext';
import { SignUpContainer } from './SignUpContainer';
import { SignUpRouter } from './SignUpRouter';
import { TrackVisitFromCampaign } from '../../tracking/TrackVisitFromCampaign';

configAxios();

try {
  const target = document.querySelector("[data-react='signup']");
  if (target) {
    ReactDOM.render(
      <>
        <SignUpProvider>
          <Crash>
            <BrowserRouter>
              <SignUpContainer>
                <SignUpRouter />
              </SignUpContainer>
            </BrowserRouter>
          </Crash>
        </SignUpProvider>
        <TrackVisitFromCampaign />
      </>,
      target,
    );
  } else {
    // eslint-disable-next-line
    console.log("data-react='signup' is not visible in the DOM");
  }
} catch (error) {
  if (window.Rollbar) {
    window.Rollbar.error(
      `Doctrine error: signup page crash for ${window.location}`,
      error,
    );
  }
}
